import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Loader from '../utils/Loader';
import { IoIosCloseCircleOutline } from 'react-icons/io';

const API = process.env.REACT_APP_Backend_Host_Name;

const StartDisputeModal = ({ isOpen, onClose, orderId, listingType, onSuccess }) => {
  const [reasons, setReasons] = useState([]);
  const [reasonCategory, setReasonCategory] = useState('product');
  const [selectedReason, setSelectedReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [loadingReasons, setLoadingReasons] = useState(true);

  const category = listingType === 'service' ? 'service' : 'product';

  useEffect(() => {
    if (!isOpen) return;
    const fetchReasons = async () => {
      setLoadingReasons(true);
      try {
        const token = localStorage.getItem('token');
        const res = await axios.get(`${API}/api/v1/orders/dispute/reasons`, {
          params: { listingType },
          headers: { Authorization: `Bearer ${token}` }
        });
        if (res.data.success) {
          setReasons(res.data.reasons || []);
          setReasonCategory(res.data.category || 'product');
          setSelectedReason('');
          setCustomReason('');
        }
      } catch (err) {
        console.error('Error fetching dispute reasons:', err);
        setReasons([]);
      } finally {
        setLoadingReasons(false);
      }
    };
    fetchReasons();
  }, [isOpen, listingType]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedReason) return;
    if (selectedReason === 'Other' && !customReason.trim()) return;

    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        `${API}/api/v1/orders/dispute/start`,
        {
          orderId,
          reasonCategory,
          reason: selectedReason,
          customReason: selectedReason === 'Other' ? customReason.trim() : undefined
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onSuccess?.();
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Failed to start dispute';
      alert(msg);
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modalOverlay disputeModalOverlay" onClick={onClose}>
      <div className="modalContent disputeModalContent" onClick={(e) => e.stopPropagation()} style={{ padding: 0 }}>
        <div className="disputeModalHeader">
          <h3>Start a Dispute</h3>
          <button type="button" className="disputeModalClose" onClick={onClose} aria-label="Close">
            <IoIosCloseCircleOutline size={22} />
          </button>
        </div>
        <div style={{ padding: '24px 28px' }}>
        <p className="disputeModalSubtext">
          Describe the issue with this order. You and the {category === 'product' ? 'seller' : 'other party'} can try to resolve it together. If needed, you can request admin involvement later.
        </p>
        <form onSubmit={handleSubmit} className="disputeModalForm">
          <div className="disputeFormGroup">
            <label>Reason for dispute</label>
            {loadingReasons ? (
              <Loader type="miniPlus" />
            ) : (
              <select
                value={selectedReason}
                onChange={(e) => {
                  setSelectedReason(e.target.value);
                  setCustomReason('');
                }}
                className="disputeSelect"
                required
              >
                <option value="">Select a reason</option>
                {reasons.map((r) => (
                  <option key={r} value={r}>{r}</option>
                ))}
              </select>
            )}
          </div>
          {selectedReason === 'Other' && (
            <div className="disputeFormGroup">
              <label>Please describe the issue</label>
              <textarea
                value={customReason}
                onChange={(e) => setCustomReason(e.target.value)}
                placeholder="Enter your reason..."
                className="disputeTextarea"
                rows={3}
                required
              />
            </div>
          )}
          <div className="disputeModalActions">
            <button type="button" className="modalButton cancel" onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className="modalButton submit"
              disabled={isLoading || !selectedReason || (selectedReason === 'Other' && !customReason.trim())}
            >
              {isLoading ? <Loader type="miniPlus" /> : 'Start Dispute'}
            </button>
          </div>
        </form>
        </div>
      </div>
    </div>
  );
};

export default StartDisputeModal;
